// @ts-nocheck
/**
 * ツインキーシステム - パッシブモジュール
 *
 * パッシブ関連のすべてのエクスポートを集約
 */

// デフォルトエクスポート用インポート（ESLint: import/first対応）
import attributePassives from './attributePassives';
import ultimatePassives from './ultimatePassives';
import uniquePassives from './uniquePassives';
import passiveResolver from './passiveResolver';

// 属性パッシブ
export {
  PASSIVE_EFFECT_TYPES,
  PASSIVE_CONDITIONS,
  ATTRIBUTE_PASSIVES,
  FIRE_PASSIVES,
  WATER_PASSIVES,
  LIGHT_PASSIVES,
  DARK_PASSIVES,
  FUTURE_PASSIVES,
  PRIMITIVE_PASSIVES,
  NEUTRAL_PASSIVES,
  getAttributePassives,
} from './attributePassives';

// 究極パッシブ
export {
  ULTIMATE_CATEGORIES,
  ATTACK_ULTIMATES,
  DEFENSE_ULTIMATES,
  HEAL_ULTIMATES,
  SUPPORT_ULTIMATES,
  SPECIAL_ULTIMATES,
  ALL_ULTIMATE_PASSIVES,
  getUltimatePassive,
  getUltimatesByCategory,
  getAllUltimateIds,
  getUltimateCount,
} from './ultimatePassives';

// 固有パッシブ
export {
  UNIQUE_PASSIVES,
  hasUniquePassives,
  getUniquePassives,
  registerUniquePassives,
  unregisterUniquePassives,
  getUniquePassiveCardIds,
} from './uniquePassives';

// パッシブ解決
export {
  PASSIVE_UNLOCK_AWAKENING,
  resolvePassives,
  getPassivesForCard,
  getPassiveSource,
  getPassiveSourceDisplayName,
  getPassiveUnlockStatus,
  isPassiveUnlocked,
  getNextPassiveUnlockAwakening,
  createPassiveInstances,
  getActivePassives,
  collectPassiveEffects,
  calculatePassiveStatBonus,
} from './passiveResolver';

// デフォルトエクスポート
export default {
  ...attributePassives,
  ...ultimatePassives,
  ...uniquePassives,
  ...passiveResolver,
};
